export const ERROR_STATUS_CODES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  REQUEST_TIMEOUT: 408, // Correct HTTP code for client-side timeout
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
  GONE: 410,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  TOO_MANY_REQUESTS: 429,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  VARIANT_ALSO_NEGOTIATES: 506,
  INSUFFICIENT_STORAGE: 507,
  LOOP_DETECTED: 508, // Now the only 508 — correct
  NOT_EXTENDED: 510,
};

export const ERROR_STATUS_CODES_VALUES = Object.values(ERROR_STATUS_CODES);
